"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectViewMode = exports.selectSortOption = exports.setViewMode = exports.toggleViewMode = exports.setSortOption = exports.SORT_OPTIONS = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
exports.SORT_OPTIONS = {
    price_asc: { param: 'price_asc', label: 'Сначала дешевле' },
    price_desc: { param: 'price_desc', label: 'Сначала дороже' },
    mileage_asc: { param: 'mileage', label: 'Минимальный пробег' },
    created_at_desc: { param: 'newest', label: 'Сначала новые' },
};
var initialState = {
    sortBy: undefined,
    viewMode: 'vertical',
};
var sortCarsSlice = (0, toolkit_1.createSlice)({
    name: 'sortCars',
    initialState: initialState,
    reducers: {
        setSortOption: function (state, action) {
            state.sortBy = action.payload;
        },
        toggleViewMode: function (state) {
            state.viewMode = state.viewMode === 'vertical' ? 'horizontal' : 'vertical';
        },
        setViewMode: function (state, action) {
            state.viewMode = action.payload;
        },
    },
});
exports.setSortOption = (_a = sortCarsSlice.actions, _a.setSortOption), exports.toggleViewMode = _a.toggleViewMode, exports.setViewMode = _a.setViewMode;
var selectSortOption = function (state) { return state.sortCars.sortBy; };
exports.selectSortOption = selectSortOption;
var selectViewMode = function (state) { return state.sortCars.viewMode; };
exports.selectViewMode = selectViewMode;
exports.default = sortCarsSlice.reducer;
